import * as types from "@/store/types";
import { mapGetters } from "vuex";
export default {
  name: "show-cards",
  components: {},
  props: ["color"],
  data() {
    return {
      // cards: [
      //   {
      //     id: 1,
      //     fa_name: "بانک ملی",
      //     en_name: "Bank Melli",
      //     card_number: "****_****_****_6651"
      //   },
      //   {
      //     id: 2,
      //     fa_name: "بانک ملت",
      //     en_name: "Bank Mellat",
      //     card_number: "****_****_****_8856"
      //   },
      //   {
      //     id: 3,
      //     fa_name: "بانک صادرات",
      //     en_name: "Bank Saderat",
      //     card_number: "****_****_****_4452"
      //   },
      //   {
      //     id: 4,
      //     fa_name: "بانک سپه",
      //     en_name: "Bank Sepah",
      //     card_number: "****_****_****_1231"
      //   },
      //   {
      //     id: 5,
      //     fa_name: "بانک پاسارگاد",
      //     en_name: "Bank Pasargad",
      //     card_number: "****_****_****_8899"
      //   },
      //   {
      //     id: 6,
      //     fa_name: "بانک پارسیان",
      //     en_name: "Bank Parsian",
      //     card_number: "****_****_****_5588"
      //   },
      //   {
      //     id: 7,
      //     fa_name: "بانک رفاه",
      //     en_name: "Bank Refah",
      //     card_number: "****_****_****_3465"
      //   },
      //   {
      //     id: 8,
      //     fa_name: "بانک اقتصاد",
      //     en_name: "Bank Eghtesad",
      //     card_number: "****_****_****_7823"
      //   },
      //   {
      //     id: 9,
      //     fa_name: "بانک سامان",
      //     en_name: "Bank Saman",
      //     card_number: "****_****_****_9512"
      //   }
      // ],
      cards: []
    };
  },
  computed: {
    ...mapGetters({
      getBankCard: types.operations.getters.GET_BANK_CARD
    }),
    getBankCardData() {
      if (this.getBankCard.length > 0) {
        return this.getBankCard;
      }
    }
  },
  mounted() {},
  methods: {}
};
